export const updateMargin = () => {
	if ( document.querySelector( 'ul.apartments[style*="margin-bottom: 0"]' ) )
	{
		document.querySelector( 'ul.apartments[style*="margin-bottom: 0"]' ).style.marginBottom = '';
	}
	
	const visibleLists = document.querySelectorAll( 'ul.apartments:not([style*="display: none"])' );

	if ( !visibleLists.length )
	{
		return;
	}

	Array.from( visibleLists )[visibleLists.length - 1].style.marginBottom = 0;
};